import { NORMALIZE_ID_WITHOUT_DASH_REGEX } from 'src/constants';

export const isSameGuid = (id1: string | undefined, id2: string | undefined): boolean => {
  return normalizeIdWithoutDash(id1 || '') === normalizeIdWithoutDash(id2 || '');
};

export const normalizeIdWithoutDash = (id: string) => {
  return id.replace(NORMALIZE_ID_WITHOUT_DASH_REGEX, '').toUpperCase();
};
